import { z } from "zod"
import { formDirtySchema } from "@/modules/patients/detail/progress-note/components/progress-note-editable/treatment-plan-section"

const defaultEditorLength = 2000

export const anamnesisSchema = z
  .object({
    anamnesis: z
      .string()
      .max(defaultEditorLength)
      .nullable()
      .superRefine((value, ctx) => {
        const trimmed = value?.trim() ?? ""
        if (trimmed.length === 0) {
          ctx.addIssue({
            code: "custom",
            message: "common.fieldErrorList.requiredField",
          })
        }
      }),
  })
  .extend(formDirtySchema.shape)

export type AnamnesisFormType = z.infer<typeof anamnesisSchema>
